import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box
} from '@mui/material';
import { Referral, Resource } from '../../../types';

interface ReferralFormProps {
  open: boolean;
  resource: Resource | null;
  onClose: () => void;
  onSubmit: (referral: Omit<Referral, 'id'>) => void;
}

export const ReferralForm: React.FC<ReferralFormProps> = ({
  open,
  resource,
  onClose,
  onSubmit
}) => {
  const [formData, setFormData] = useState({
    studentId: '',
    date: new Date().toISOString().split('T')[0],
    status: 'pending',
    notes: '',
    followUpDate: ''
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (resource) {
      onSubmit({
        ...formData,
        resourceId: resource.id,
        status: 'pending'
      });
    }
    onClose();
  };

  if (!resource) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <form onSubmit={handleSubmit}>
        <DialogTitle>New Referral - {resource.name}</DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
            <FormControl fullWidth>
              <InputLabel>Student</InputLabel>
              <Select
                value={formData.studentId}
                label="Student"
                onChange={(e) => setFormData({ ...formData, studentId: e.target.value })}
              >
                <MenuItem value="1">John Doe</MenuItem>
                <MenuItem value="2">Jane Smith</MenuItem>
              </Select>
            </FormControl>

            <TextField
              label="Referral Date"
              type="date"
              value={formData.date}
              onChange={(e) => setFormData({ ...formData, date: e.target.value })}
              fullWidth
            />

            <TextField
              label="Notes"
              multiline
              rows={4}
              value={formData.notes}
              onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
              fullWidth
            />

            <TextField
              label="Follow-up Date"
              type="date"
              value={formData.followUpDate}
              onChange={(e) => setFormData({ ...formData, followUpDate: e.target.value })}
              fullWidth
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button type="submit" variant="contained" color="primary">
            Create Referral
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};